export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE"
export const REMOVE_ROUTE = "REMOVE_ROUTE"